<fieldset class="form-inline">
  <div class="form-group w-100">
    <input
      #searchField
      matInput
      id="typeahead-http"
      type="text"
      class="form-control w-100"
      [placeholder]="placeholder"
      [class.is-invalid]="searchFailed"
      [(ngModel)]="model"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="formatter"
      [editable]="false"
      (focus)="focus()"
      (blur)="blur()"
      (selectItem)="select($event)"
    />
    <small *ngIf="searching" class="form-text text-muted">searching...</small>
    <div class="invalid-feedback" *ngIf="searchFailed">
      Sorry, suggestions could not be loaded.
    </div>
  </div>
</fieldset>
